/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Tenancy_Node_Type_Enum_Ps_Enum } from '@pypestream/api-services';

import { TableNode, NodeColumns, columnOrder, defaultRowData } from '..';
import { escapeJsonValues } from '../../components/table/utils';

const normalizeTableData = (
  data: TableNode[],
  order = columnOrder,
  defaults = defaultRowData
): TableNode[] => {
  return data.map((row) => {
    const normalized: TableNode = {} as TableNode;

    for (const key of order) {
      if (key in row) {
        // @ts-ignore
        normalized[key] = row[key];
      } else if (key in defaults) {
        // @ts-ignore
        normalized[key] = defaults[key];
      } else {
        // @ts-ignore
        normalized[key] = null;
      }
    }

    return normalized;
  });
};

const customJSONStringify = (data: unknown[]): string => {
  const raw = JSON.stringify(data, null, 0);

  const arr = JSON.parse(raw);

  const formattedObjects = arr.map((obj: Record<string, unknown>) => {
    return (
      '  ' +
      JSON.stringify(obj, null, 0).replace(/^{/, '{ ').replace(/}$/, ' }')
    );
  });

  return `[\n${formattedObjects.join(',\n')}\n]`;
};

export const prepareRowsDataForPifCompiler = (data: TableNode[]) => {
  const tableRows = data.map(
    ({
      nodeNumber,
      nodeType,
      output,
      variables,
      whatsNext,
      nextNodes,
      ...rest
    }) => {
      const normalizeVariables = (vars?: string[]): string[] => {
        if (!vars || vars.length === 0) return [];

        const result = vars
          .flatMap((v) => v?.split(','))
          .map((s) => s?.trim())
          .filter(Boolean);

        return result.length > 0 ? result : [];
      };

      return {
        nodeNumber: Number.isFinite(Number(nodeNumber))
          ? Number(nodeNumber)
          : nodeNumber,
        nodeType: nodeType.toUpperCase() as Tenancy_Node_Type_Enum_Ps_Enum,
        output: output || [],
        whatsNext: whatsNext ? whatsNext.join('|') : null,
        nextNodes: nextNodes
          ? nextNodes.map((n) => (Number.isFinite(Number(n)) ? Number(n) : n))
          : [],
        variables: normalizeVariables(variables),
        ...rest,
      };
    }
  );

  const dataForCompiling = customJSONStringify(
    // @ts-ignore
    normalizeTableData(tableRows, columnOrder, defaultRowData)
      .map(
        ({
          richAssetType,
          richAssetContent,
          cssClassname,
          analyticsEvent,
          ...rest
        }) => ({
          ...rest,
          cssClassName: cssClassname,
          richAsset: { type: richAssetType, content: richAssetContent },
        })
      )
      .map((item) => escapeJsonValues(item, [NodeColumns.whatsNext]))
  );

  return dataForCompiling;
};
